import { Language } from '../../enums/language.enum';
import { getTranslatedRoutePath } from './get-translated-route-path';

export type TranslatableSegment = symbol | string | number;

export function translateSegments(
	segments: TranslatableSegment[],
	language: Language,
	excludeFragment = false
): string[] {
	return segments.map((segment) => {
		switch (typeof segment) {
			case 'symbol': {
				return getTranslatedRoutePath(segment, language);
			}
			default: {
				if (excludeFragment) {
					const segmentWithoutFragment = segment.toString().split('#')[0];
					return segmentWithoutFragment;
				}

				return segment.toString();
			}
		}
	});
}
